import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger } from '@/Domain/components/Shared/Tabs/Tabs';

type Props = {
  isBillingYearly: boolean;
  onChange: (isBillingYearly: boolean) => void;
};

export const PricingIntervalToggle = ({ isBillingYearly, onChange }: Props) => {
  const { t } = useTranslation('subscription_page');

  return (
    <Tabs
      value={isBillingYearly ? 'annually' : 'monthly'}
      onValueChange={(value) => onChange(value === 'annually')}
    >
      <TabsList>
        <TabsTrigger value="monthly" data-testid="pricing-toggle-monthly">
          {t('pricing.toggle.monthly')}
        </TabsTrigger>
        <TabsTrigger value="annually" data-testid="pricing-toggle-annually">
          {t('pricing.toggle.annually')}
          <span className="rounded-sm bg-success-muted px-2 py-0.5 text-xs font-medium text-success">
            {t('pricing.toggle.discount_off')} ({t('pricing.toggle.months_free')})
          </span>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};
